<template>
  <ConfirmDialog :group="SEND_STOPS_CONFIRM_GROUP">
    <template #message="slotProps">
      <div class="p-confirm-dialog-message-wrapper">
        <span class="p-confirm-dialog-message">{{ slotProps.message.message }}</span>
        <ul v-if="slotProps.message.stoppedSubjects && slotProps.message.stoppedSubjects.length" class="mt-3 mb-0 pl-4">
          <li v-for="subject in slotProps.message.stoppedSubjects" :key="subject">{{ subject }}</li>
        </ul>
      </div>
    </template>
  </ConfirmDialog>
</template>

<script>
import ConfirmDialog from 'primevue/confirmdialog';
import { SEND_STOPS_CONFIRM_GROUP } from "@/helpers/sendStops";

export default {
  name: "SendStopsConfirmDialog",
  components: { ConfirmDialog },
  data() {
    return {
      SEND_STOPS_CONFIRM_GROUP,
    }
  },
}
</script>
